import { Injectable } from "@nestjs/common";
import { Donors } from "../donor.entity";
import { DonorsDTO } from "./donor.dto";

@Injectable()
export class DonorAdapter {

    public 
    convertDtoToEntity(donorsDto:DonorsDTO , isUpdate: boolean = false): Donors {
        const donors = new Donors
        donors.donorsId = donorsDto.donorsId;
        donors.donorName = donorsDto.donorName;
        donors.phoneNo = donorsDto.phoneNo;
        donors.country = donorsDto.country;
        donors.state = donorsDto.state;
        donors.district = donorsDto.district;
        donors.constituency = donorsDto.constituency;
        donors.bloodGroup = donorsDto.bloodGroup;
        donors.createdAt = donorsDto.createdAt;
        // donors.isActive=donorsDto.isActive==undefined?true:donorsDto.isActive;
    // if (isUpdate) {
    //     donors.updatedUser = donorsDto.updatedUser;
    // } else {
    //     donors.isActive = true;
    //     donors.createdUser = donorsDto.createdUser;
    // }
   return donors;
    }
    public convertEntityToDto( donorObj :Donors ): DonorsDTO {
       const  donorsDto = new DonorsDTO
        donorsDto.donorsId = donorObj.donorsId;
        donorsDto.donorName = donorObj.donorName;
        donorsDto.phoneNo = donorObj.phoneNo;
        donorsDto.country = donorObj.country;
        donorsDto.state = donorObj.state;
        donorsDto.district = donorObj.district;
        donorsDto.constituency = donorObj.constituency;
        donorsDto.bloodGroup = donorObj.bloodGroup;
        donorsDto.createdAt = donorObj.createdAt;
        return donorsDto;
    }
}
